/**
 * @generated SignedSource<<5ddb8b69eee67d3a5cc870de6832944f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type ProfileDisplayType = "BASIC" | "BLOG" | "RESOURCE" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type ProfileLayout_userProfile$data = {
  readonly avatarImage: {
    readonly id: string;
    readonly uid: string;
    readonly url: string;
  } | null;
  readonly displayUsername: string;
  readonly hasActivePortfolio: boolean;
  readonly hasCompletedClientOnboarding: boolean;
  readonly hasCompletedIndyOnboarding: boolean;
  readonly introductionVideo: {
    readonly isEnabled: boolean;
    readonly video: {
      readonly uid: string;
    };
  } | null;
  readonly profileDisplayType: ProfileDisplayType;
  readonly receivedTestimonials: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly recommend: boolean;
      };
    }>;
  };
  readonly recommendationRequests: {
    readonly count: number;
  };
  readonly title: string | null;
  readonly visitorCanEdit: boolean;
  readonly " $fragmentSpreads": FragmentRefs<"NewProfileSidebar_userProfile" | "OpportunitiesTab_userProfile" | "RecommendationsTab_userProfile" | "ServicesTab_userProfile" | "UncontrolledHeadlineEditor_userProfile" | "WorkTab_userProfile">;
  readonly " $fragmentType": "ProfileLayout_userProfile";
};
export type ProfileLayout_userProfile$key = {
  readonly " $data"?: ProfileLayout_userProfile$data;
  readonly " $fragmentSpreads": FragmentRefs<"ProfileLayout_userProfile">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "uid",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ProfileLayout_userProfile",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "displayUsername",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "visitorCanEdit",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasActivePortfolio",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasCompletedClientOnboarding",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasCompletedIndyOnboarding",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "profileDisplayType",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ReceivedTestimonialConnection",
      "kind": "LinkedField",
      "name": "receivedTestimonials",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "ReceivedTestimonialEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Testimonial",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "recommend",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "RecommendationRequestConnection",
      "kind": "LinkedField",
      "name": "recommendationRequests",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "count",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "IntroductionVideo",
      "kind": "LinkedField",
      "name": "introductionVideo",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isEnabled",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "ContraVideo",
          "kind": "LinkedField",
          "name": "video",
          "plural": false,
          "selections": [
            (v0/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ContraImage",
      "kind": "LinkedField",
      "name": "avatarImage",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "url",
          "storageKey": null
        },
        (v0/*: any*/)
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "WorkTab_userProfile"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ServicesTab_userProfile"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "OpportunitiesTab_userProfile"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "RecommendationsTab_userProfile"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "UncontrolledHeadlineEditor_userProfile"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "NewProfileSidebar_userProfile"
    }
  ],
  "type": "UserProfile",
  "abstractKey": null
};
})();

(node as any).hash = "cebe1ff1497f01cb751ba47ba1cdc5a1";

export default node;
